import { render, staticRenderFns } from "./JobDetail.vue?vue&type=template&id=038f306b&scoped=true"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"
import style0 from "./JobDetail.vue?vue&type=style&index=0&id=038f306b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038f306b",
  null
  
)

export default component.exports